/** CMS URL for the live feed listing (Subscribe CTA, post–sign-out redirect). */
export const LIVE_FEEDS_PAGE_PATH = "/live-feeds";

export const POST_LOGOUT_REDIRECT_PATH = LIVE_FEEDS_PAGE_PATH;

/**
 * Nav Sign In / Subscribe are limited to these paths until the live-feed flow is ready site-wide.
 */
export function showNavAuthTestOnPath(pathname) {
  if (!pathname || typeof pathname !== "string") return false;
  const p = pathname.split("?")[0];
  return (
    p === "/live-streams" ||
    p.startsWith("/live-streams/") ||
    p === "/live-feeds" ||
    p.startsWith("/live-feeds/") ||
    p === "/demo-live-feeds" ||
    p.startsWith("/demo-live-feeds/")
  );
}
